import cookies from 'js-cookie'
import globals from '../../utils/globals'

const controlEvents = [
  '[Control] User Visited',
  'Article Version History Viewed',
  'Article Title Updated',
  'Article Scheduled',
  'Article Published',
  'Article Draft Created',
  'Badge Awarded',
  'Badge Revoked',
  'Custom View Opened',
  'Custom View Saved',
  'Custom View Shared',
  'Team Note Saved',
  'SSO Configuration Saved',
  'Role Changed',
  'Post Moved Error',
  'Post Moved',
  'Post Escalated',
  'Post Edit Submitted',
  'IP Information Clicked',
  'Event Created',
  'Escalate Post Clicked',
  'Escalation URL Clicked',
  'Category Page Saved',
  'Reply Pinned',
  'Reply Unpinned',
  'Dashboard viewed',
  'Email Campaign Saved',
  'Email Campaign Sent',
  'Email Campaign Test Email Sent',
  'Content Sharing Settings Changed',
  'Contact Invited',
  'Idea status assigned',
  'Idea votes merged',
  'Ideation Data Exported'
]

function trackEvent (eventName, eventPayload, cb) {
  const environment = globals('environment')
  const region = globals('region')
  const communityId = globals('communityId')
  const http = new window.XMLHttpRequest()

  if (!environment || !region || !communityId) {
    return cb && cb(null)
  }

  if (controlEvents.includes(eventPayload.type)) {
    const { user: { userid } } = window.inSidedData
    Object.assign(eventPayload, { userid, event_source: 'control' })
  } else {
    Object.assign(eventPayload, { event_source: 'destination' })
  }

  http.open('POST', globals('eventLogger'), true)
  http.withCredentials = true
  http.onreadystatechange = () => {
    if (http.readyState === 4) {
      if (http.status >= 200 && http.status < 400) {
        if (http.response) {
          const { visitor } = JSON.parse(http.response)
          const visitorCookie = cookies.get('tu')
          if (!visitorCookie || visitorCookie !== visitor) cookies.set('tu', visitor, { expires: 365 * 2 })
        }
        if (cb) return cb(null)
      }
      if (cb) return cb(new Error(http.responseText))
    }
  }
  const payload = JSON.stringify(Object.assign(
    {},
    eventPayload,
    { eventName, communityId }
  ))
  http.send(payload)
}

export default { trackEvent }
